import { render, staticRenderFns } from "./DashbourdTabs.vue?vue&type=template&id=0b940c68&"
import script from "./DashbourdTabs.vue?vue&type=script&lang=ts&"
export * from "./DashbourdTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports